<template>
  <footer class="footer-section">
    <!-- 상단: 프로모션 배너 -->
    <div class="promo-banner">
      <div class="promo-content">
        <span class="promo-tag">YONGIN × SAMSUNG</span>
        <h3 class="promo-title">용인 반도체 클러스터 <strong>최대 수혜</strong> 입지</h3>
        <p class="promo-sub">용인 첨단시스템반도체 국가산업단지(삼성전자) 초근접 프리미엄</p>
      </div>
    </div>

    <!-- 중간: 메인 정보 영역 -->
    <div class="footer-main">
      <div class="footer-inner">
        <!-- 좌측: 브랜드 & 전화번호 -->
        <div class="footer-brand">
          <div class="brand-logo">
            <img src="@/assets/logo/logo_white.png" alt="용인남사 대우이안 플렉시티" class="logo-img" />
          </div>
          <a href="tel:1644-4220" class="footer-phone">
            <span class="phone-label">대표문의</span>
            <span class="phone-number">1644-4220</span>
          </a>
          <!-- 대표문의 하단 줄글 정보 -->
          <dl class="brand-info-list">
            <div class="info-row">
              <dt>현장명</dt>
              <dd>용인 이안 플렉시티</dd>
            </div>
            <div class="info-row">
              <dt>현장위치</dt>
              <dd>용인특례시 처인구 남사읍 아곡리 456번지 일원</dd>
            </div>
            <div class="info-row">
              <dt>광고대행사</dt>
              <dd>더한걸음 - 원스텝애드</dd>
            </div>
          </dl>
        </div>

        <!-- 우측: 카드 그리드 (시행사 / 자금관리 / 현장 / CTA) -->
        <div class="info-cards">
          <div class="info-card">
            <span class="border-line line-top"></span>
            <span class="border-line line-right"></span>
            <span class="border-line line-bottom"></span>
            <span class="border-line line-left"></span>
            <span class="info-card-value">10년<br/>안심거주</span>
          </div>
          <div class="info-card">
            <span class="border-line line-top"></span>
            <span class="border-line line-right"></span>
            <span class="border-line line-bottom"></span>
            <span class="border-line line-left"></span>
            <span class="info-card-value">HUG<br/>안심보증</span>
          </div>
          <div class="info-card">
            <span class="border-line line-top"></span>
            <span class="border-line line-right"></span>
            <span class="border-line line-bottom"></span>
            <span class="border-line line-left"></span>
            <span class="info-card-value">반도체 국가산단<br/>초근접입지</span>
          </div>
          <div class="info-card cta-card" @click="openInterestModal">
            <span class="border-line line-top"></span>
            <span class="border-line line-right"></span>
            <span class="border-line line-bottom"></span>
            <span class="border-line line-left"></span>
            <span class="cta-title">상담신청</span>
            <span class="cta-btn">발코니 확장비 무상<br/>백화점 상품권 증정</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 하단: 저작권 -->
    <div class="footer-bottom">
      <div class="footer-inner">
        <div class="disclaimers">
          <p>광고대행 : 더한걸음 &nbsp;|&nbsp; 대표자 : 백영민 &nbsp;|&nbsp; 사업자번호 : 820-87-03644</p>
          <p>사업장 주소 : 경기도 화성시 동탄구 동탄신리천로 270, 4층 402-d160호</p>
        </div>
        <div class="copyright">
          <span>Copyright ⓒ 2026 용인남사 대우이안 플렉시티. All rights reserved.</span>
          <router-link to="/privacy" class="privacy-link">개인정보처리방침</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  methods: {
    openInterestModal() {
      if (window.innerWidth > 768) {
        this.$router.push('/reservation/register')
      } else {
        window.dispatchEvent(new CustomEvent('open-register-modal'))
      }
    }
  }
}
</script>

<style scoped>
.footer-section {
  width: 100%;
  height: 100vh;
  background: #0a0a0a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding-top: 120px;
}

/* 프로모션 배너 */
.promo-banner {
  flex: 0 0 auto;
  background: linear-gradient(135deg, var(--ecofore-primary) 0%, var(--ecofore-primary-dark) 100%);
  padding: 56px 0;
  position: relative;
  z-index: 1;
  text-align: center;
}

.promo-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 40px;
}

.promo-tag {
  display: inline-block;
  font-family: var(--font-paperlogy);
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 4px;
  margin-bottom: 18px;
  padding: 8px 18px;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.promo-title {
  font-family: var(--font-pretendard);
  font-size: 34px;
  font-weight: 300;
  color: #fff;
  margin: 0 0 14px;
  letter-spacing: -0.5px;
  line-height: 1.35;
}

.promo-title strong {
  font-weight: 800;
  color: #fff;
  position: relative;
}

.promo-title strong::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 6px;
  background: rgba(255, 255, 255, 0.25);
  z-index: -1;
}

.promo-sub {
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  letter-spacing: -0.2px;
}


/* 푸터 메인 */
.footer-main {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}

.footer-inner {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.footer-main .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 80px;
}

/* 브랜드 영역 */
.footer-brand {
  flex: 0 0 auto;
}

.brand-logo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 32px;
  margin-bottom: 40px;
}

.brand-logo .logo-img {
  width: 120px;
  height: auto;
  object-fit: contain;
  display: block;
}

.logo-main {
  font-family: var(--font-pretendard);
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}

.logo-sub {
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}

.footer-phone {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-decoration: none;
  padding: 24px 36px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.footer-phone:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: var(--ecofore-primary);
}

.phone-label {
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 3px;
}

.phone-number {
  font-family: var(--font-paperlogy);
  font-size: 32px;
  font-weight: 700;
  color: var(--ecofore-primary);
  letter-spacing: 2px;
}

/* ===== 정보 카드 그리드 ===== */
.info-cards {
  flex: 1;
  max-width: 560px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

/* 좌측 대표문의 아래 줄글 정보 */
.brand-info-list {
  margin: 24px 0 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  font-family: var(--font-pretendard);
  font-size: 13px;
  line-height: 1.6;
}

.info-row dt {
  flex-shrink: 0;
  min-width: 100px;
  color: var(--ecofore-primary);
  font-weight: 600;
  letter-spacing: 0.3px;
}

.info-row dd {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  word-break: keep-all;
}

.info-card {
  position: relative;
  padding: 28px 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  transition: background 0.3s ease;
}

.info-card:hover {
  background: rgba(255, 255, 255, 0.05);
}

.info-card-label {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 600;
  color: var(--ecofore-primary);
  letter-spacing: 2px;
}

.info-card-value {
  font-family: var(--font-pretendard);
  font-size: 18px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: -0.3px;
}

/* 이메일 링크 */
.info-link {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease;
}

.info-link:hover {
  color: var(--ecofore-primary);
}

/* CTA 카드 */
.cta-card {
  cursor: pointer;
  border-color: rgba(140, 199, 81, 0.3);
  background: rgba(140, 199, 81, 0.06);
  align-items: center;
  justify-content: center;
  text-align: center;
}

.cta-card:hover {
  background: rgba(140, 199, 81, 0.15);
}

.cta-title {
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.3px;
  line-height: 1.4;
}

.cta-btn {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 700;
  color: var(--ecofore-primary);
  letter-spacing: -0.2px;
  line-height: 1.5;
  padding-top: 8px;
  margin-top: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
}

/* 우측 상단 꼭짓점 핀 벳지 */
.cta-badge {
  position: absolute;
  top: -12px;
  right: -8px;
  z-index: 5;
  background: linear-gradient(135deg, #ff8a1e, #ff2d55);
  color: #fff;
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: -0.3px;
  line-height: 1;
  padding: 6px 12px;
  border-radius: 999px;
  white-space: nowrap;
  box-shadow: 0 6px 16px rgba(255, 45, 85, 0.5), 0 0 0 2px rgba(255, 255, 255, 0.15);
  animation: ctaBadgePulse 1.8s ease-in-out infinite;
}

@keyframes ctaBadgePulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}

/* ===== 호버 보더 라인 애니메이션 ===== */
.border-line {
  position: absolute;
  background: var(--ecofore-primary);
  transition: all 1.2s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 2;
}

.line-top {
  top: 0;
  left: 0;
  width: 0;
  height: 2px;
}

.line-right {
  top: 0;
  right: 0;
  width: 2px;
  height: 0;
}

.line-bottom {
  bottom: 0;
  right: 0;
  width: 0;
  height: 2px;
}

.line-left {
  bottom: 0;
  left: 0;
  width: 2px;
  height: 0;
}

.info-card:hover .line-top { width: 100%; }
.info-card:hover .line-right { height: 100%; }
.info-card:hover .line-bottom { width: 100%; }
.info-card:hover .line-left { height: 100%; }

/* 푸터 하단 */
.footer-bottom {
  flex: 0 0 auto;
  padding: 30px 0 100px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  position: relative;
  z-index: 1;
}

.footer-bottom .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 40px;
}

.disclaimers {
  flex: 1;
}

.disclaimers p {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.3);
  line-height: 1.8;
  margin-bottom: 4px;
}

.disclaimers p:last-child {
  margin-bottom: 0;
}

.copyright {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.copyright span {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
}

.privacy-link {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.3s ease;
}

.privacy-link:hover {
  color: var(--ecofore-primary);
}

/* ===== 태블릿 (max-width: 1024px) ===== */
@media (max-width: 1024px) {
  .promo-content {
    padding: 0 32px;
  }

  .promo-title {
    font-size: 28px;
  }

  .promo-sub {
    font-size: 14px;
  }

  .footer-main .footer-inner {
    gap: 40px;
  }

  .info-cards {
    max-width: 440px;
  }
}

/* ===== 모바일 (max-width: 768px) ===== */
@media (max-width: 768px) {
  .footer-section {
    height: 100vh;
    height: 100dvh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: center;
    padding-top: 80px;
  }

  /* 프로모션 배너 - 컴팩트 */
  .promo-banner {
    padding: 28px 0;
  }

  .promo-content {
    padding: 0 20px;
  }

  .promo-tag {
    font-size: 10px;
    letter-spacing: 2px;
    padding: 5px 12px;
    margin-bottom: 12px;
  }

  .promo-title {
    font-size: 19px;
    margin-bottom: 8px;
    line-height: 1.4;
    word-break: keep-all;
  }

  .promo-sub {
    font-size: 12px;
    word-break: keep-all;
  }

  /* 메인 정보 영역 - 컴팩트 */
  .footer-main {
    flex: 0 0 auto;
    padding: 20px 0;
  }

  .footer-inner {
    padding: 0 20px;
  }

  .footer-main .footer-inner {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }

  /* 모바일 순서 재배치: 로고 → 대표문의 → 2x2 카드 → 줄글 */
  .footer-brand {
    display: contents;
  }

  .brand-logo { order: 1; text-align: center; align-items: center; }
  .footer-phone { order: 2; align-self: center; }
  .info-cards { order: 3; }
  .brand-info-list { order: 4; }

  .brand-logo {
    align-items: center;
    margin-bottom: 12px;
    gap: 4px;
  }

  .logo-main {
    font-size: 18px;
  }

  .footer-phone {
    display: inline-flex;
    padding: 12px 24px;
    min-height: 44px;
    align-items: center;
    gap: 6px;
    flex-direction: row;
  }

  .phone-label {
    font-size: 12px;
    letter-spacing: 1px;
    color: rgba(255, 255, 255, 0.6);
  }

  .phone-number {
    font-size: 24px;
  }

  .logo-sub {
    color: rgba(255, 255, 255, 0.7);
  }

  /* 정보 카드 - 컴팩트 2x2 그리드 */
  .info-cards {
    max-width: none;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .info-card {
    padding: 14px 12px;
    gap: 6px;
  }

  .brand-info-list {
    margin-top: 16px;
    gap: 4px;
  }

  .info-row {
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
  }

  .info-row dt {
    min-width: auto;
  }

  .info-card-label {
    font-size: 11px;
    letter-spacing: 1px;
    color: rgba(255, 255, 255, 0.6);
  }

  .info-card-value {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.95);
  }

  .cta-card {
    padding: 14px 12px;
    min-height: 48px;
  }

  .cta-title {
    font-size: 15px;
  }

  .cta-btn {
    font-size: 13px;
  }

  /* 호버 보더 라인 - 모바일에서 비활성 */
  .border-line {
    display: none;
  }

  /* 하단 면책조항 - 컴팩트 */
  .footer-bottom {
    padding: 16px 0 24px;
  }

  .footer-bottom .footer-inner {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 12px;
  }

  .disclaimers p {
    font-size: 10.5px;
    line-height: 1.6;
    margin-bottom: 2px;
    color: rgba(255, 255, 255, 0.5);
  }

  .copyright {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
    justify-content: space-between;
  }

  .copyright span {
    color: rgba(255, 255, 255, 0.6);
  }

  .copyright span {
    font-size: 10.5px;
  }

  .privacy-link {
    font-size: 12px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.7);
  }
}

/* ===== 작은 모바일 (max-width: 480px) ===== */
@media (max-width: 480px) {
  .promo-banner {
    padding: 20px 0;
  }

  .promo-tag {
    font-size: 10px;
  }

  .promo-title {
    font-size: 20px;
  }

  .promo-sub {
    font-size: 14px;
  }

  .footer-main {
    padding: 16px 0;
  }

  .footer-inner {
    padding: 0 16px;
  }

  .logo-main {
    font-size: 18px;
  }

  .phone-number {
    font-size: 22px;
  }

  .info-cards {
    gap: 6px;
  }

  .info-card {
    padding: 12px 10px;
  }

  .info-card-value {
    font-size: 14px;
  }

  .footer-bottom {
    padding: 12px 0 20px;
  }

  .disclaimers p {
    font-size: 9.5px;
  }
}
</style>
